import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';

import HomePage from '../../pages/homePage';
import AboutPage from '../../pages/aboutPage';
import TeamPage from '../../pages/teampage';
import BlogPage from '../../pages/blogPage';
import BlogPostPage from '../../pages/blogPostPage';
import FaqPage from '../../pages/faqPage';
import ContactUsPage from '../../pages/contactUsPage';
import AccessibilityPage from '../../pages/accessibilityPage';
import PrivacyPolicy from '../../pages/privacyPolicy';
import LegalDisclaimer from '../../pages/legalDisclaimer';
import PageNotFound from '../../pages/404PageNotFound';

import ImmigrationPage from '../../pages/practiceAreas/immigrationPage';
import PersonalInjuryPage from '../../pages/practiceAreas/personalInjuryPage';
import LemonLawPage from '../../pages/practiceAreas/lemonLawPage';
// import WorkersCompensationPage from '../../pages/practiceAreas/workersCompensationPage';
import EmploymentLawPage from '../../pages/practiceAreas/employmentLaw';

// import GlendaleOffice from '../../pages/locations/glendaleOffice';
// import SacramentoOffice from '../../pages/locations/sacramentoOffice';

const SUPPORTED_LANGS = new Set(['en', 'ru', 'hy', 'es']);

// ✅ FORCE /en → /en/
const LangRedirect = () => {
  const { lang } = useParams();
  return <Navigate to={`/${lang}/`} replace />;
};

// ✅ Language handler
const LanguageRouterWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!lang || !SUPPORTED_LANGS.has(lang)) {
      navigate('/en/', { replace: true });
      return;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, navigate]);

  return children;
};

const AppRoutes = ({ myRef }) => (
  <Routes>
    {/* ROOT → /en/ */}
    <Route path="/" element={<Navigate to="/en/" replace />} />

    {/* /en → /en/ */}
    <Route path="/:lang" element={<LangRedirect />} />

    {/* HOME */}
    <Route
      path="/:lang/"
      element={
        <LanguageRouterWrapper>
          <HomePage myRef={myRef} />
        </LanguageRouterWrapper>
      }
    />

    {/* PAGES */}
    <Route
      path="/:lang/about"
      element={
        <LanguageRouterWrapper>
          <AboutPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/immigration"
      element={
        <LanguageRouterWrapper>
          <ImmigrationPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/personalinjury"
      element={
        <LanguageRouterWrapper>
          <PersonalInjuryPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/lemonlaw"
      element={
        <LanguageRouterWrapper>
          <LemonLawPage />
        </LanguageRouterWrapper>
      }
    />
    {/*<Route*/}
    {/*  path="/:lang/workerscomp"*/}
    {/*  element={*/}
    {/*    <LanguageRouterWrapper>*/}
    {/*      <WorkersCompensationPage />*/}
    {/*    </LanguageRouterWrapper>*/}
    {/*  }*/}
    {/*/>*/}
    <Route
      path="/:lang/employmentlaw"
      element={
        <LanguageRouterWrapper>
          <EmploymentLawPage />
        </LanguageRouterWrapper>
      }
    />

    {/* OFFICE LOCATION LANDING PAGES - coming next, see /src/pages/locations */}
    {/*<Route*/}
    {/*  path="/:lang/glendale-office"*/}
    {/*  element={*/}
    {/*    <LanguageRouterWrapper>*/}
    {/*      <GlendaleOffice />*/}
    {/*    </LanguageRouterWrapper>*/}
    {/*  }*/}
    {/*/>*/}
    {/*<Route*/}
    {/*  path="/:lang/sacramento-office"*/}
    {/*  element={*/}
    {/*    <LanguageRouterWrapper>*/}
    {/*      <SacramentoOffice />*/}
    {/*    </LanguageRouterWrapper>*/}
    {/*  }*/}
    {/*/>*/}

    <Route
      path="/:lang/team"
      element={
        <LanguageRouterWrapper>
          <TeamPage />
        </LanguageRouterWrapper>
      }
    />
    {/*<Route*/}
    {/*  path="/:lang/useful-links"*/}
    {/*  element={*/}
    {/*    <LanguageRouterWrapper>*/}
    {/*      <UsefulLinks />*/}
    {/*    </LanguageRouterWrapper>*/}
    {/*  }*/}
    {/*/>*/}
    <Route
      path="/:lang/blog"
      element={
        <LanguageRouterWrapper>
          <BlogPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/blog/:blogTitle"
      element={
        <LanguageRouterWrapper>
          <BlogPostPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/faq"
      element={
        <LanguageRouterWrapper>
          <FaqPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/contact-us"
      element={
        <LanguageRouterWrapper>
          <ContactUsPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/accessibility"
      element={
        <LanguageRouterWrapper>
          <AccessibilityPage />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/privacy-policy"
      element={
        <LanguageRouterWrapper>
          <PrivacyPolicy />
        </LanguageRouterWrapper>
      }
    />
    <Route
      path="/:lang/legal-disclaimer"
      element={
        <LanguageRouterWrapper>
          <LegalDisclaimer />
        </LanguageRouterWrapper>
      }
    />

    {/* 404 */}
    <Route
      path="/:lang/*"
      element={
        <LanguageRouterWrapper>
          <PageNotFound />
        </LanguageRouterWrapper>
      }
    />

    {/* fallback */}
    <Route path="*" element={<Navigate to="/en/" replace />} />
  </Routes>
);

export default AppRoutes;
